import React from 'react';
import cauri1 from '../images/ilustrations/Anye_cauri1.svg';
import cauri2 from '../images/ilustrations/Anye_cauri2.svg';
import cauri3 from '../images/ilustrations/Anye_cauri3.svg';
import cauri4 from '../images/ilustrations/Anye_cauri4.svg';
import cauri5 from '../images/ilustrations/Anye_cauri5.svg';

// Cauris distribuidos en la parte inferior, como en la referencia
const cauris = [
  { src: cauri3, left: '35%', top: '65%', width: 100, rotate: 25,  delay: 0 },
  { src: cauri2, left: '46%', top: '80%', width: 100, rotate: -15, delay: 1.2 },
  { src: cauri5, left: '55%', top: '76%', width: 70, rotate: 40,  delay: 0.6 },
  { src: cauri4, left: '40%', top: '77%', width: 90, rotate: -30, delay: 1.8 },
  { src: cauri1, left: '57%', top: '68%', width: 90, rotate: 10,  delay: 2.5 },
];

export default function DecorativeCauri() {
  return (
    <div
      className="DecorativeCauri"
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 1,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      {cauris.map((c, i) => (
        <img
          key={i}
          src={c.src}
          alt=""
          className="Cauri-item"
          style={{
            position: 'absolute',
            left: c.left,
            top: c.top,
            width: c.width,
            height: 'auto',
            objectFit: 'contain',
            transform: `rotate(${c.rotate}deg)`,
            animationDelay: `${c.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
